export default {
    PRZELEWY24_INSTALLMENT_CONFIG: '.js-przelewy24-installment-calculator-config',
    PRZELEWY24_INSTALLMENT_CALCULATOR_MODAL: 'calculator-modal',
    PRZELEWY24_INSTALLMENT_WIDGET_MAX: 'installment-widget-max',
    PRZELEWY24_INSTALLMENT_WIDGET_MAX_SELECTOR: '.js-przelewy24-installment-widget-max'
}
